/**
 * RosterPlannerConnected — the Shift Planner (Troi) wired to a session, for the
 * Home detail pane (the agent working IN the frame), like CarePlanBoardConnected /
 * AllocationBoardConnected. It renders the shared RosterWorkspace: a board-first
 * agentic UI where the roster board is the agent's face and the plan is the
 * hero, NOT a chat box.
 *
 * The roster is SHIFT ROWS: the board reads GET /shifts for the team and window
 * it is showing, and every edit — the lead's tap-to-assign, a published
 * proposal — is a write to that resource. It used to be an event-sourced
 * command log folded out of this session's transcript, which meant nobody
 * outside the conversation could read the ward's roster. Author vs viewer, the
 * read seam, and Troi's demoted chat channel all live in useRosterController;
 * this file is the pane's mount point.
 *
 * Session-less like every board face (AccessBoardConnected precedent): the
 * board reads need no session, and the planner chat's first send mints one
 * (useDeferredFirstSend), with onSessionCreated transitioning the caller.
 */
import type { SessionResponse } from '@frontend/api/types_session'
import type { SessionDetail } from '@frontend/hooks/useSessions'

import { RosterWorkspace } from './RosterWorkspace'

interface RosterPlannerConnectedProps {
  /** Present on the Session page / detail pane; absent on the session-less
   *  Home face (the board reads stand alone; the planner chat mints the
   *  session on its first send). */
  session?: SessionDetail
  /** Face mode only. The roster has no patient frame (team scope) — present
   *  for AgentFaceProps parity. */
  facePatientId?: string | null
  /** Face mode only — fires once the planner chat's first send mints the session. */
  onSessionCreated?: (session: SessionResponse) => void
}

export function RosterPlannerConnected({ session, onSessionCreated }: RosterPlannerConnectedProps) {
  return <RosterWorkspace session={session} onSessionCreated={onSessionCreated} />
}
